import "core-js/modules/es.array.concat";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { menuAside, menuHeader } from '@/menu';
import store from "@/store/index";
import changTime from "@/utils/changTime";
import router from "@/router";
export default {
  namespaced: true,
  state: {
    d2Pageinfo: {},
    UnskipRoute: '',
    pas: false,
    CurrentRouter: '',
    // 暂存当前路由
    rebound: ['/financial/backhaulConfigurationJL'],
    // 设置产品后需要回跳的页面
    isAuthority: false,
    // 是否开启选择产品
    // 需要选择产品才能进入的页面
    kamitakuAuthorityList: ['/kamitaku/kamitakuFlow', '/kamitaku/kamitakuactivityRetain', '/kamitaku/kamitakuLtv', '/kamitaku/kamitakuAd', '/kamitaku/kamitakuTopup', '/kamitaku/kamitakuCheckpoint', '/financial/shareProportion', '/financial/adRevenue', '/financial/InstalledVolume', '/financial/consumptionDetails', '/financial/backhaulConfigurationJL'],
    exchangeRate: {
      VND: 1,
      USD: 1,
      date: ''
    }
  },
  actions: {
    setPageinfo: function setPageinfo(_ref, info) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref.state, dispatch = _ref.dispatch;
                state.d2Pageinfo = info; // 设置数据

                dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'd2Pageinfo',
                  value: info,
                  user: false
                }, {
                  root: true
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getPageinfo: function getPageinfo(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref2.state, dispatch = _ref2.dispatch;
                _context2.next = 3;
                return dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'd2Pageinfo',
                  defaultValue: {},
                  user: false
                }, {
                  root: true
                });

              case 3:
                state.d2Pageinfo = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    gogameIndex: function gogameIndex(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, dispatch, accessMenus, allMenuAside, allMenuHeader;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref3.state, dispatch = _ref3.dispatch;
                _context3.next = 3;
                return store.dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'menu.accessMenus',
                  defaultValue: [],
                  user: true
                }, {
                  root: true
                });

              case 3:
                accessMenus = _context3.sent;
                allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus));
                allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus)); // 设置顶栏菜单

                store.commit('d2admin/menu/headerSet', allMenuHeader); // 设置侧边栏菜单

                store.commit('d2admin/menu/asideSet', allMenuAside); // 初始化菜单搜索功能

                store.commit('d2admin/search/init', allMenuHeader);
                store.dispatch('d2admin/serchSelect/setPageStatus', 1);
                router.push('/');

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  mutations: {
    setPageinfo: function setPageinfo(state, data) {
      state.d2Pageinfo = data;
    },
    setUnskipRoute: function setUnskipRoute(state, data) {
      state.UnskipRoute = data;
    },
    setCurrentRouter: function setCurrentRouter(state, data) {
      state.CurrentRouter = data;
    },
    setPas: function setPas(state, data) {
      state.pas = data;
    },
    setExchangeRate: function setExchangeRate(state, data) {
      console.log(store);
      var newData = {
        VND: state.exchangeRate.VND,
        USD: state.exchangeRate.USD
      };

      if (data.key == 'VND') {
        newData.VND = data.value || 1;
      } else if (data.key == 'USD') {
        newData.USD = data.value || 1;
      }

      state.exchangeRate = _objectSpread(_objectSpread({}, newData), {}, {
        date: changTime.theDay()
      });
    }
  }
};